import { render, staticRenderFns } from "./ISO.vue?vue&type=template&id=1d985d87&scoped=true&"
import script from "./ISO.vue?vue&type=script&lang=ts&"
export * from "./ISO.vue?vue&type=script&lang=ts&"
import style0 from "./ISO.vue?vue&type=style&index=0&id=1d985d87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d985d87",
  null
  
)

export default component.exports